var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35.9718,
    rx: 6,
    fill: "#D6DEF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7001 13.2361L22.7788 10.2999C22.5858 10.1078 22.3245 10 22.0522 10C21.7799 10 21.5187 10.1078 21.3256 10.2999L10.9692 20.6414L10.0237 24.7222C9.99104 24.8714 9.99216 25.026 10.0269 25.1747C10.0617 25.3234 10.1293 25.4624 10.2247 25.5816C10.32 25.7009 10.4409 25.7973 10.5783 25.8639C10.7157 25.9304 10.8663 25.9655 11.019 25.9664C11.0901 25.9736 11.1618 25.9736 11.233 25.9664L15.3586 25.0208L25.7001 14.6893C25.8922 14.4963 26 14.235 26 13.9627C26 13.6904 25.8922 13.4292 25.7001 13.2361ZM14.861 24.125L10.9941 24.9362L11.875 21.144L19.6236 13.4252L22.6096 16.4112L14.861 24.125ZM23.2765 15.6896L20.2905 12.7036L22.0224 10.9817L24.9586 13.9677L23.2765 15.6896Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledEdit);
export default __webpack_public_path__ + "static/media/filledEdit.1db84db60d8b3e324bb5f39e430788e5.svg";
export { ForwardRef as ReactComponent };